export function transactionLinkId(
  origTranId: number | string | null | undefined,
): string | undefined {
  const id = Number(origTranId)
  if (!Number.isFinite(id) || id <= 0) return undefined
  return String(id)
}
